import { LendingInfo } from 'domain/types';

export function hasMultiMarketLending(lendings: LendingInfo[]): boolean {
  return lendings.some(l => l.isMultiMarket);
}
